/** @jsx h */

import {h, render, Component} from "preact";
import AsyncSelect  from 'react-select/async'
import {onFind} from "@elements/init-modules-in-scope";
import {getPrefixedDataSet} from "@elements/data-set-utils";
import throwError from "@elements/throw-error";
import {useState} from "preact/hooks";
import {translate} from '@elements/translations';
import escapeHtml from 'escape-html';

const defaultSelectors = {
    base: '.js-typeahead'
};

const defaultOptions = {
    isClearable: true,
    defaultValue: ""
};

export function init(options = defaultOptions, selectors = defaultSelectors) {
    onFind(selectors.base, function (baseElement) {
        let options = {
            ...defaultOptions,
            ...options,
            ...transformDataSetOptions(getPrefixedDataSet('typeahead', baseElement))
        };
        
        render(<TypeaheadConfig isClearable={options.isClearable}
                                placeholder={options.placeholder}
                                value={options.defaultValue}
                                defaultIsOpen={false}
                                name={options.name}
                                minLength={options.minLength}
                                defaultOptions={options.options}/>,
            baseElement);
    });
}


function TypeaheadConfig({
        defaultOptions = [],
        value = "",
        placeholder = "",
        defaultIsOpen = false,
        name = "default-name",
        minLength = 0
    }) {
    

    const [inputValue, setInputValue] = useState(value);
    const [isOpen, setIsOpen] = useState(defaultIsOpen);

    const loadData = (stringValue, callback) => {
        const _config = window._config || {};
        if (!_config.typeaheadDataUrl) {
            console.warn(`"_config.typeaheadDataUrl" is not set`);
        }

        let data = {
            query: stringValue
        };

        const url = addParamsToUrl(_config.typeaheadDataUrl, data);

        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(result => result.json()).then(result => {
            if (result.success === true) {
                callback(result.data.options);
            }
        }).catch(e => {
            console.error(`Could not load configuration data for typeahead`, e);
        });
    };


    const handleInputChange = (newValue) => {
        let newInput = escapeHtml(newValue);
        setInputValue({ newInput });
        if(newInput.length > +minLength) {
            setIsOpen(true);
        } else {
            setIsOpen(false);
        }
        return newInput;
    };

    const styling = {
        control: styles => ({ ...styles, color:'#fff', backgroundColor: '#222222', borderWidth: '0' }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            const color = '#fff';
            return {
                ...styles,
                backgroundColor: isFocused ? '#fff' : '#222222',
                color: isFocused ? '#222222' : '#fff',
                borderBottom: '1px solid #fff',
                cursor: isDisabled ? 'not-allowed' : 'default',
            }
        },
        menu: styles => ({ ...styles, backgroundColor: '#222222'}),
        loadingIndicator: styles => ({ ...styles, color:'#fff'})
    };


    return (
        <AsyncSelect
            name={name}
            className="react-select-wrapper"
            classNamePrefix="react-select"
            cacheOptions
            menuIsOpen={isOpen}
            loadOptions={isOpen ? loadData : ''}
            defaultOptions
            placeholder={placeholder}
            styles={styling}
            onInputChange={handleInputChange}
        />
    )
}


function transformDataSetOptions(options = {}) {
    let transformedOptions = {...options};

    if (transformedOptions.options) {
        try {
            transformedOptions.options = JSON.parse(transformedOptions.options)
        } catch (e) {
            transformedOptions.options = null;
            throwError(OPTIONS_ERROR_MESSAGE);
        }
    }

    return transformedOptions;
}

export const addParamsToUrl = (url, params) =>
    url + (url.indexOf('?') >= 0 ? '&': '?')
    + Object.entries(params)
        .map(([key, value]) => `${key}=${value}`)
        .join('&');


const OPTIONS_ERROR_MESSAGE = `Typeahead error: data-typeahead-options has to be a a valid JSON object. Most likely you used single quotes instead of double quotes for the JSON fields.`;

